import type { Dispatch, SetStateAction } from 'react';
import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import ModbenBenefitImage from '../modben-benefit-image/modben-benefit-image';
import { SectionContainer } from './styles';
import type { ImageForm } from './types';

interface ModbenBenefitImageElementProps {
  form: ImageForm;
  isCloneBenefit: boolean;
  setIsUploadInProgress: Dispatch<SetStateAction<boolean>>;
}

const ModbenBenefitImageElement = ({
  form,
  isCloneBenefit,
  setIsUploadInProgress,
}: ModbenBenefitImageElementProps) => (
  <SectionContainer>
    <FormProvider {...form}>
      <ModbenBenefitImage
        isCloneBenefit={isCloneBenefit}
        setIsUploadInprogress={setIsUploadInProgress}
      />
    </FormProvider>
  </SectionContainer>
);

export default memo(ModbenBenefitImageElement);
